(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-2 
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.titles :as titles]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.style.theme.core :as theme]
   [potpuri.core :as potpuri]))

(defn basic-information
  [{:keys [basic-information language]}]
  [(card/first-row-first-column-card
    (titles/resolve-dasos-titles-with-lang :basic-information language)
    false
    (block-table-pdf/table basic-information {:table-widths [125 230]
                                              :font-size 7.5
                                              :custom-heading-color (theme/color [:palette :grey-20])
                                              :custom-heading-font-color "#ffffff"}))])

(defn nav-per-unit-series
  [{:keys [nav-per-unit-series language]}]
  [(card/second-row-first-column-card
    (titles/resolve-dasos-titles-with-lang :nav-per-unit-series language)
    false
    (horizontal-table-pdf/table nav-per-unit-series {:table-widths [180 60 50 50]
                                                     :font-size 7.5
                                                     :custom-heading-color (theme/color [:palette :grey-20])
                                                     :custom-heading-font-color "#ffffff"}))])

(defn total-return-by-unit-series
  [{:keys [total-return-by-unit-series language]}]
  [(card/second-row-second-column-card
    (titles/resolve-dasos-titles-with-lang :total-return-by-unit-series language)
    false
    (horizontal-table-pdf/table total-return-by-unit-series {:font-size 7.5
                                                             :custom-heading-color (theme/color [:palette :grey-20])
                                                             :custom-heading-font-color "#ffffff"}))])

(defn unit-value
  [{:keys [unit-value language]}]
  [(card/first-row-second-column-card
    (titles/resolve-dasos-titles-with-lang :unit-value language)
    false
    {:svg (chart-view/chart-svg "highcharts"
                                (potpuri/deep-merge (:figures unit-value)
                                                    {:chart  {:width   760
                                                              :height  350
                                                              :spacing [10 0 10 0]
                                                              :margin  [100 80 80 50]
                                                              :style {:fontSize "18px"}}
                                                     :legend {:verticalAlign "top"
                                                              :align         "left"
                                                              :floating      true
                                                              :padding       10}}))
     :fit [page/page-width-half 220]}
    (text-content/optional-footer unit-value))])

(defn view
  [data]
  (page/page
   (page/page-title-with-line {:fund-name  (:fund-name data)
                               :reference-date (:reference-date data)
                               :lower-case-title? true})
   (column/half-columns
    [(basic-information data)
     (unit-value data)]
    [(nav-per-unit-series data)
     (total-return-by-unit-series data)])))
